import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.element.addEventListener("turbo:submit-start", this._onSubmitStart.bind(this))
    this.element.addEventListener("turbo:submit-end", this._onSubmitEnd.bind(this))
  }

  _onSubmitStart() {
    if (!this.hasSubmitTarget) return

    this._originalContent = this.submitTarget.innerHTML
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("opacity-75", "cursor-not-allowed")
    this.submitTarget.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      ${this.submitTarget.dataset.loadingText || "Saving..."}
    `
  }

  _onSubmitEnd() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = false
    this.submitTarget.classList.remove("opacity-75", "cursor-not-allowed")
    if (this._originalContent) {
      this.submitTarget.innerHTML = this._originalContent
    }
  }
}
